function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#D7F6EE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7667 20.9558L32.4346 24.2723C34.0549 24.8045 35.1631 26.3009 35.1996 28.0059V39.2173C35.2672 39.9358 34.9762 40.6415 34.4217 41.1036C33.8673 41.5657 33.1208 41.7248 32.4261 41.5289L22.7743 38.9047C21.1527 38.4002 20.0356 36.9149 20.0008 35.217V23.0007C19.9643 21.3878 21.2363 20.0477 22.849 20H37.5998C39.3672 20 40.8 21.4328 40.8 23.2002V32.7507C40.7924 33.6221 40.4383 34.4546 39.8158 35.0644C39.1934 35.6743 38.3538 36.0113 37.4824 36.0011H35.1996",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7994 32.0007C31.0204 32.0007 31.1995 32.1798 31.1995 32.4008C31.1995 32.6217 31.0204 32.8008 30.7994 32.8008C30.5785 32.8008 30.3994 32.6217 30.3994 32.4008C30.3994 32.1798 30.5785 32.0007 30.7994 32.0007",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M40.7996 28.0005H35.1992",
  stroke: "#4C4C4C",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgMoneyWalletOpen = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "owned-tokens-context-icon",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoneyWalletOpen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/money-wallet-open.0f8b4358.svg";
export { ForwardRef as ReactComponent };